// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsScreen__headerTitle___Tkr2K {
    text-align: center;
    color: #363636;
}


.TermsScreen__h2___j1V_S {
    padding-top: 2vh;
    color: #363636;
}

.TermsScreen__h3___WipeW {
    padding-top: 2vh;
    color: #363636;
}


.TermsScreen__p___cTeVc {
    padding-top: 2vh;
    line-height: 1.5;
    color: #363636;
}

.TermsScreen__a____n0w7 {
    color: #363636;
}


.TermsScreen__ul___MZSX3, .TermsScreen__ol___NGfyn {
    padding-top: 1vh;
    padding-left: 2vw;
}

.TermsScreen__li___WahIh {
    padding-bottom: 1vh;
    line-height: 1.5;
    color: #363636;
}

.TermsScreen__hLine___V5jUU {
    margin-top: 3vh;
    border-top: 1px solid lightgray;
}

.TermsScreen__link___qpPni {
    text-decoration: none;
    color: #6060FF;
}

.TermsScreen__link___qpPni:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/website/css/TermsScreen.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".headerTitle {\n    text-align: center;\n    color: #363636;\n}\n\n\n.h2 {\n    padding-top: 2vh;\n    color: #363636;\n}\n\n.h3 {\n    padding-top: 2vh;\n    color: #363636;\n}\n\n\n.p {\n    padding-top: 2vh;\n    line-height: 1.5;\n    color: #363636;\n}\n\n.a {\n    color: #363636;\n}\n\n\n.ul, .ol {\n    padding-top: 1vh;\n    padding-left: 2vw;\n}\n\n.li {\n    padding-bottom: 1vh;\n    line-height: 1.5;\n    color: #363636;\n}\n\n.hLine {\n    margin-top: 3vh;\n    border-top: 1px solid lightgray;\n}\n\n.link {\n    text-decoration: none;\n    color: #6060FF;\n}\n\n.link:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerTitle": `TermsScreen__headerTitle___Tkr2K`,
	"h2": `TermsScreen__h2___j1V_S`,
	"h3": `TermsScreen__h3___WipeW`,
	"p": `TermsScreen__p___cTeVc`,
	"a": `TermsScreen__a____n0w7`,
	"ul": `TermsScreen__ul___MZSX3`,
	"ol": `TermsScreen__ol___NGfyn`,
	"li": `TermsScreen__li___WahIh`,
	"hLine": `TermsScreen__hLine___V5jUU`,
	"link": `TermsScreen__link___qpPni`
};
export default ___CSS_LOADER_EXPORT___;
